import React, { Component } from 'react';
import { Container } from 'flux/utils';
import { Store } from 'model';
import './styles.less';
import Suggestion from './suggestion';

class BaseSuggestions extends Component {

	render() {
		var { recommendations, visible, active, onSelect } = this.state;

		if(visible) {

			var items = recommendations.map(function(item, index) {
				var id = item.src + index;
				return <Suggestion key={id} item={item} onSelect={onSelect} active={ index === active } />
			});

			return <ul ref={(list) => { this.list = list; }} className="dropdown-menu suggestions-box" style={{ display: 'block' }}>
				{ items }
			</ul>;
		} else {
			return null;
		}

	}
}

class Suggestions extends BaseSuggestions {

	static getStores() {
		return [Store];
	}

	static calculateState(state, props) {
		var state = Store.getState();

		return {
			recommendations: Store.getRecommendations(),
			visible: state.visible,
			active: state.active,
			onSelect: props.onSelect
		}
	}
}

export default Container.create(Suggestions, { withProps: true })
export { BaseSuggestions };




// WEBPACK FOOTER //
// ./src/modules/app/search/suggestions/component.js